import { usePropertyField } from '../usePropertyField';

// ─── Top-level ────────────────────────────────────────────────────────────────

export const usePropertyStructureType = (propertyGuid: string) =>
    usePropertyField(propertyGuid, (p) => p.structureType, (p, v) => ({ ...p, structureType: v }));
